import type { ComponentType, ReactNode } from "react";
import { cn } from "../../lib/cn";
import { Inbox, type LucideProps } from "lucide-react";

export function EmptyState({
  icon: Icon = Inbox,
  title = "Nothing here",
  description,
  action,
  className,
}: {
  icon?: ComponentType<LucideProps>;
  title?: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("text-center py-12 px-6", className)}>
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl glass-subtle mb-4">
        <Icon className="w-6 h-6 text-slate-300" />
      </div>
      <h3 className="text-base font-semibold text-white">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-slate-400 max-w-md mx-auto">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
